import { Esia } from '@acme/features';

const EsiaLoginPage = () => {
  return (
    <div className="font-inter flex w-full flex-col gap-2 pb-10 text-center leading-[normal] items-center px-12">
      <Esia />
    </div>
  );
};

export { EsiaLoginPage };
